import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import Chip from '@mui/material/Chip';

const styles = theme => ({
    chip: {
        margin: theme.spacing(1)
    }
});


class Groupe extends React.Component {

    render() {

        const { groupe, format } = this.props;

        let _format = format;
        if (!_format) {
            _format = "deletablechip";
        }


        if (_format === "deletablechip") {

            return (
                    <Chip
                        label={groupe.libelle}
                        onDelete={this.props.onDelete}
                    />
            );
        }



        return groupe.libelle;

    }
}

Groupe.propTypes = {
    format: PropTypes.string,
    groupe: PropTypes.object.isRequired,
    onDelete: PropTypes.func
};

export default withStyles(styles)(Groupe);